import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';

export const usePromoCodeStore = create(
  devtools(
    combine(
      {
        promoCodeStore: '' as string,
        errorPromoCode: '' as string,
        isForceClosePromoModal: false,
      },
      (set) => ({
        setPromoCodeStore: (promoCodeStore: string) => {
          set({ promoCodeStore });
        },
        setErrorPromoCode: (errorPromoCode: string) => {
          set({ errorPromoCode });
        },
        setIsForceClosePromoModal: (isForceClosePromoModal: boolean) => {
          set({ isForceClosePromoModal });
        },
        resetPromoCodeStore: () => {
          set({
            promoCodeStore: '',
            errorPromoCode: '',
            isForceClosePromoModal: false,
          });
        },
      })
    )
  )
);
